module.exports = __webpack_public_path__ + "23558209fc85acfde9b031ebce5d254e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/news/img1_2.jpg
// module id = 397
// module chunks = 0